var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 26.4,
    width: 0,
    height: 0
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20.9,26.7 20.9,26.7 20.9,26.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.6,27.8 21.6,27.8 21.6,27.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.5,27.3 21.5,27.3 21.5,27.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.7,26.5 19.7,26.5 19.7,26.5  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,0C9,0,0,9,0,20s9,20,20,20s20-9,20-20S31,0,20,0z M18.1,11.2c0-0.9,0.9-1.7,2-1.7c1.1,0,2,0.7,2,1.7v9.9 c0,0.9-0.9,1.7-2,1.7c-1.1,0-2-0.7-2-1.7V11.2z M22.6,28.1c0,0.1,0,0.2,0,0.3c0,0.1,0,0.1,0,0.2c0,0.1-0.1,0.2-0.1,0.3 c0,0.1-0.1,0.2-0.1,0.2c0,0.1-0.1,0.2-0.1,0.2c0,0-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0.2 c0,0-0.1,0.1-0.2,0.1c-0.1,0.1-0.2,0.1-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.2,0-0.2,0.1 c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.2,0c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.2-0.1-0.2-0.1 c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.2-0.1-0.2-0.2c-0.1,0-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2 c0,0-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.3 c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.2c0-0.1,0-0.2,0-0.2c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.1,0.1-0.2 c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0.1-0.1,0.2-0.2c0-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.1-0.1,0.1-0.1,0.2-0.1 c0.1-0.1,0.2-0.1,0.2-0.1c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.2-0.1,0.2-0.1c0.1,0,0.2,0,0.2-0.1c0.1,0,0.2,0,0.2,0c0.2,0,0.4,0,0.5,0 c0.1,0,0.2,0,0.2,0c0.1,0,0.2,0,0.2,0.1c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.2,0.1,0.2,0.1c0,0,0.1,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.2,0.1 c0.1,0.1,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.1,0.2c0,0.1,0.1,0.1,0.1,0.2 c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.2C22.6,28,22.6,28.1,22.6,28.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.5,28.5 21.5,28.5 21.5,28.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.8,27.2 18.8,27.2 18.8,27.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.6,28.1 21.6,28.1 21.6,28.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.3,
    y: 29.2,
    width: 0,
    height: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.a7d83a42.svg";
export { ForwardRef as ReactComponent };